import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Notifications.frontend.types'

@Injectable({ providedIn: 'root' })
export class Notifications_alerts_findService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { application_name?: string, level?: number }): Promise<{ alerts?: { alert_id?: string, application_name?: string, alert_name?: string, level?: number, to?: string, cc?: string, bcc?: string, subject?: string, pdf?: boolean, filters?: { name?: string, value?: string }[] }[], success?: boolean, messages?: any[] }> 
  {
    let url = `${environment.backendUrl}api/Notifications/functions/alerts_find`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

